import logger from '@move-web-essentials-utils/logger';
const getVariable = (key) => typeof window !== 'undefined' && window.__ENV__ !== undefined
    ? window.__ENV__[key]
    : process.env[key];
/**
 * Get a value from the environment, logs a missing environment variable.
 *
 * @param key - the name of the environment variable
 * @param ignore - ignores missing variable, defaults to false. Otherwise, displays a console error log.
 * @returns the value of the environment variable.
 *
 * @example
 * ```
 * const FOO_ENV_VALUE = getEnv('MV_PUBLIC_FOO')
 * const BAR_ENV_VALUE = getEnv('BAR')
 * ```
 */
export const getEnv = (key, ignore) => {
    const value = getVariable(key);
    if (!ignore && typeof value === 'undefined') {
        logger.error(`Undefined environment variable: ${key}`);
    }
    return value;
};
